/**
 * Created by fers on 28.01.16.
 */
/* global module */
import Relay from 'react-relay';
import React from 'react';
import ReactDOM from 'react-dom';
import createRoutes from './createRoutes';
import applyRouterMiddleware from 'react-router/lib/applyRouterMiddleware';
import Router from 'react-router/lib/Router';
import useRouterHistory from 'react-router/lib/useRouterHistory';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import 'whatwg-fetch';
import {getLocale} from './locales';
import {getMessages} from './getMessages';
import {displayError} from './app/errorDisplayer';
import {IntlProvider} from 'react-intl';
import useScroll from 'react-router-scroll/lib/useScroll';
import ElementQueries from 'css-element-queries/src/ElementQueries';
import {isScreenSettingsOnlyIframe, isEmbeddedLogin} from '../outlook/dialog';
import useRelay from './react-router-relay/index';
import {isLogged} from './app/auth.js';
import EventTracker from './app/EventTracker';
import * as Registration from './registration/Registration.react';
import * as Login  from './registration/Login.react';
import initRelayLayer from './initRelayLayer';
import {isSafari} from '../../packages/extension/src/background/browser';
import LastOrganisationId from './app/LastOrganisationId';
import AutoCreateOrganisationMutation from './home/AutoCreateOrganisationMutation';
import { collectUISettings } from './app/UISettings.react';

// import CacheManager from 'relay-cache-manager';

// attaches to DOMLoadContent and does  anything for you
ElementQueries.listen();
const history = useRouterHistory(createBrowserHistory)({ queryKey: false });
EventTracker.trackLocationChange(history);

const routes = createRoutes();

let promise = Promise.resolve();
if (Registration.isRegistration()) {
	if (isLogged() && window.location.hash !== '#hard') {
		window.location = window.location.origin;
	}
	else {
		promise = Registration.init();
	}
}
else if (!isLogged()) {
	promise = Login.login();
}

if (isSafari()) {
	document.body.classList.add('safari');
}

collectUISettings();

let RelayNetworkLayer;

promise
	.then(() => {
		RelayNetworkLayer = initRelayLayer();
		Relay.injectNetworkLayer(RelayNetworkLayer);
	})
	.then(() => {
		return new Promise((resolve, reject) => {
			if (!LastOrganisationId.get()) {

				let onFailure = (e) => {
					displayError(e);
					// nothing for now
					resolve();
				};

				let onSuccess = (result) => {
					LastOrganisationId.set(result.autoCreateOrganisation.organisationId);
					resolve();
				};

				Relay.Store.commitUpdate(new AutoCreateOrganisationMutation(), {
					onFailure,
					onSuccess
				});
			}
			else {
				resolve();
			}
		});
	})
	.then(() => {
		// const cacheManager = new CacheManager();
		// Relay.Store.getStoreData().injectCacheManager(cacheManager);


		if (isEmbeddedLogin()) {
			window.close();
		}

		if (isScreenSettingsOnlyIframe()) {
			document.body.className = "screen-settings-only";
		}

		if (module.hot) {
			import(/* webpackChunkName: "react-hot-loader" */ 'react-hot-loader').then((val) => {
				let AppContainer = val.AppContainer;

				const render = (passedRoutes) => {
					ReactDOM.render(
						<IntlProvider locale={getLocale()} messages={getMessages()}>
							<AppContainer>
								<Router
									environment={Relay.Store}
									history={history}
									key={Math.random()}
									render={applyRouterMiddleware(useScroll(), useRelay)}
									routes={passedRoutes}
								/>
							</AppContainer>
						</IntlProvider>,
					document.getElementById('app'));
				};

				render(routes);

				module.hot.accept('./createRoutes', () => {
					const createRoutesNewGetter = require('./createRoutes').default;
					const createRoutesNew = createRoutesNewGetter();

					render(createRoutesNew);
				});
			}).catch((e) => { displayError(e); });
		}
		else {
			ReactDOM.render(
				<IntlProvider locale={getLocale()} messages={getMessages()}>
					<Router
						environment={Relay.Store}
						history={history}
						render={applyRouterMiddleware(useScroll(), useRelay)}
						routes={routes}
					/>
				</IntlProvider>,
				document.getElementById('app')
			);
		}
	}).catch((e) => {
		displayError(e);
	});
